/** True for App workspace data screens (list / record / report / print / mail). */
export function isAppDataPath(pathname: string): boolean {
  if (pathname.startsWith('/app/')) return true
  // /reports/:reportId — but not the bare /reports index if it ever exists
  if (/^\/reports\/[^/]+/.test(pathname)) return true
  // /print/:sessionId is a print TAB; bare /print is the standalone page.
  if (/^\/print\/[^/]+/.test(pathname)) return true
  if (pathname === '/administration/mail') return true
  return false
}

/** Path identity for a tab: pathname + search when ?form= (or any query) is present. */
export function tabPathFromLocation(pathname: string, search: string): string {
  return search ? `${pathname}${search}` : pathname
}
